import React from "react";
import {
    OverlayDrawer,
    DrawerHeader,
    DrawerHeaderTitle,
    DrawerBody,
} from "@fluentui/react-components";
import { Dismiss24Regular } from "@fluentui/react-icons";
import ASCButton from "../../../components/Button";
import { formatedDate } from "../../../utils";
import { makeStyles, shorthands, tokens } from "@fluentui/react-components";

const useStyles = makeStyles({
    drawer: {
        // Positioning logic for bottom-right
        top: "auto",
        // bottom: "20px",
        // right: "20px",
        height: "65%",
        width: "350px",
        position: "fixed",

        // Visual styling
        ...shorthands.borderRadius(tokens.borderRadiusXLarge),
        ...shorthands.border("1px", "solid", tokens.colorNeutralStroke1),
        boxShadow: tokens.shadow28,
    },
    detailItem: {
        marginBottom: "16px",
    },
    label: {
        display: "block",
        fontSize: "20px", // Standard label size
        color: tokens.colorNeutralForeground4,
        fontWeight: tokens.fontWeightSemibold,
        marginBottom: "2px",
    },
    value: {
        display: "block",
        fontSize: "20px", // Increased font size for values
        color: tokens.colorNeutralForeground1,
        fontWeight: tokens.fontWeightMedium,
        ...shorthands.margin(0),
    },
});

interface CommissionDetailDrawerProps {
    isOpenDistributionDetailDrawer: boolean;
    handleDistributionDetailPopup: (open: boolean) => void;
    activeItem: any;
}


// 1. Define the labels based on your table columns
const commissionLabels = [
    { label: "Status", value: "status" },
    { label: "Standard Amount", value: "standardAmount" },
    { label: "Consultant ", value: "consultant" },
    { label: "Client", value: "clientName" },
    { label: "Provider", value: "provider" },
    { label: "Party Name", value: "partyName" },
    { label: "Party Type", value: "partyType" },
    { label: "Commission Type", value: "commissionType" },
    { label: "Expected", value: "expected" },
    { label: "Rule Amount", value: "ruleAmount" },
    { label: "Received Amount", value: "receivedAmount" },
    { label: "Due Date", value: "dueDate" },
    { label: "Note", value: "note" },
];

// 2. Helper for date rendering
const renderDate = (date: string) => (date ? formatedDate(date) : "-");

const CommissionDetailDrawer: React.FC<CommissionDetailDrawerProps> = ({
    isOpenDistributionDetailDrawer,
    activeItem,
    handleDistributionDetailPopup,
}) => {

    const styles = useStyles();
    return (
        <OverlayDrawer
            position="end"
            open={isOpenDistributionDetailDrawer}
            onOpenChange={(_, { open }) => handleDistributionDetailPopup(open)}
            className={styles.drawer}

        >
            <DrawerHeader>
                <DrawerHeaderTitle
                    action={
                        <ASCButton
                            shape="rounded"
                            appearance="subtle"
                            aria-label="Close"
                            icon={<Dismiss24Regular />}
                            onClick={() => handleDistributionDetailPopup(false)}
                        />
                    }
                >
                    Distribution Details
                </DrawerHeaderTitle>
            </DrawerHeader>
            <DrawerBody>
                <div className="case-detail-container">
                    {activeItem && Object.keys(activeItem).length > 0 ? (
                        <div>
                            {commissionLabels.map((item, index) => (
                                <div key={`comm_${index}`} className="details">
                                    <p className="details_label">{item.label}</p>
                                    <p>
                                        {(() => {
                                            const val = activeItem[item.value];
                                            switch (item.value) {
                                                case "dueDate":
                                                    return renderDate(val);
                                                case "expected":
                                                case "ruleAmount":
                                                case "receivedAmount":
                                                    return val !== undefined && val !== null ? val : "0.00";
                                                default:
                                                    return val || "";
                                            }
                                        })()}
                                    </p>
                                </div>
                            ))}
                        </div>
                    ) : (
                        <p>No details selected</p>
                    )}
                </div>
            </DrawerBody>
        </OverlayDrawer>
    );
};

export default CommissionDetailDrawer;